import { __awaiter } from "tslib";
import Macro from "./Macro";
export default class Parallel extends Macro {
    constructor(...subactions) {
        super(...subactions);
        this._name = "Parallel";
    }
    action(ctx) {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.all(this.subactions.map(subaction => subaction.execute(ctx)));
        });
    }
}
